import { render, staticRenderFns } from "./FilterOrkDialog.vue?vue&type=template&id=542940ea&"
import script from "./FilterOrkDialog.vue?vue&type=script&lang=js&"
export * from "./FilterOrkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports